import { atom } from 'jotai';
import { loadable } from 'jotai/utils';
import { fetchUserPacks } from '../api/packInventory';

// Async atom — fetches user packs and derives total count on first read
const packCountFetchAtom = atom(async () => {
    const packs = await fetchUserPacks();
    return packs.reduce((sum, p) => sum + p.amount, 0);
});

const packCountLoadableAtom = loadable(packCountFetchAtom);
const packCountOverrideAtom = atom(null);

// Self-loading, writable. Returns 0 while loading.
export const packCountAtom = atom(
    (get) => {
        const override = get(packCountOverrideAtom);
        if (override !== null) return override;
        const fetched = get(packCountLoadableAtom);
        return fetched.state === 'hasData' ? fetched.data : 0;
    },
    (get, set, update) => {
        const override = get(packCountOverrideAtom);
        let current;
        if (override !== null) {
            current = override;
        } else {
            const fetched = get(packCountLoadableAtom);
            current = fetched.state === 'hasData' ? fetched.data : 0;
        }
        set(packCountOverrideAtom, typeof update === 'function' ? update(current) : update);
    }
);
